import { Component }                                                                       from "@angular/core";
import { BaseComponent, Transfer, PageService, PageComponent, Shell, AppConfig }           from "common";
import { ActivatedRoute, Router }                                                          from "@angular/router";
import { TopicApi, ApiTopic, ApiTopicItem, ApiFullTopicItem, FollowApi, ApiFollowedTopic } from "api";
import { combineLatest }                                                                   from "rxjs";
import { UserService, LoginComponent }                                                     from "user";
import { User }                                                                            from "models";
import * as stringDistance                                                                 from 'js-levenshtein';
import { environment } from "@tytapp/environment";

@Component({
    selector: 'tyt-topic-feed',
    templateUrl: './topic-feed-page.component.html',
    styleUrls: ['./topic-feed-page.component.scss']
})
export class TopicFeedPageComponent extends PageComponent {
    public isUTMCampaign: any = false;

    constructor(
        pageService : PageService,
        private route : ActivatedRoute,
        private topicApi : TopicApi,
        private followApi : FollowApi,
        private userService : UserService,
        private appConfig: AppConfig
    ) {
        super(pageService);
    }

    @Transfer()
    topic : ApiTopic;

    @Transfer()
    items : ApiFullTopicItem[];

    @Transfer()
    ready : boolean = false;

    @Transfer()
    total : number;

    @Transfer()
    size : number;

    @Transfer()
    page : number;

    getPurchaseUrl () {
      return environment.urls.purchase;
    }

    goToPage(page : number) {
        this.router.navigate([], { queryParams: { page } })
    }

    async follow() {
        if (!this.user) {
            this.router.navigateByUrl('/signup');
            //this.shell.showDialog(LoginComponent);
            return;
        }

        await this.followApi.followTopic(Object.assign({}, this.topic, { is_followed: true })).toPromise();

        this.follows = this.follows.filter(x => x.slug !== this.topic.slug);
        this.follows.push(Object.assign({}, this.topic, { is_followed: true }));
    }

    async unfollow() {
        if (!this.user) {
            this.router.navigateByUrl('/signup');
            //this.shell.showDialog(LoginComponent);
            return;
        }

        await this.followApi.followTopic(Object.assign({}, this.topic, { is_followed: false })).toPromise();

        this.follows = this.follows.filter(x => x.slug !== this.topic.slug);
        this.follows.push(Object.assign({}, this.topic, { is_followed: false }));
    }

    get spotIdentifier() {
        if (!this.topic)
            return null;

        return `topic_${this.topic.slug}`;
    }

    noSuchTopic = false;

    private async fetchTopic(slug) {

        this.noSuchTopic = false;
        this.ready = false;
        try {
            this.topic = await this.topicApi.get(slug).toPromise();
        } catch (e) {
            if (e.status === 404) {
                let topics = await this.topicApi.all().toPromise();
                let results = [];

                for (let topic of topics) {
                    let distance = stringDistance(slug, topic.slug);
                    results.push({ distance, topic });
                }

                results = results.sort((a, b) => a.distance - b.distance);
                let topResult = results[0];

                if (topResult.distance < 5) {
                    this.router.navigateByUrl(`/topics/${topResult.topic.slug}`);
                    return;
                }

                this.noSuchTopic = true;

                if (results[0].distance < 10) {
                    this.recommendedTopic = results[0].topic;
                } else {
                    this.recommendedTopic = null;
                }


                return;
            }

            throw e;
        }
        this.ready = true;
    }

    recommendedTopic : ApiTopic;

    private async fetchTopicFeed(slug, offset) {
        this.items = null;
        try {
            this.items = await this.topicApi
                .getTopicFeed(slug, offset, this.size)
                .toPromise();
        } catch (e) {
            if (e.status === 404) {
                this.noSuchTopic = true;
                return;
            }

            throw e;
        }
        this.total = this.items['total'];
    }

    private async fetchFollowStatus() {
        if (this.user) {
            this.follows = await this.followApi.getFollows().toPromise();
        } else {
            this.follows = [];
        }
    }

    get isFollowed() {
        if (!this.follows || !this.topic)
            return false;

        let followedTopic = this.follows.find(x => x.slug === this.topic.slug);

        if (!followedTopic)
            return false;

        return followedTopic.is_followed;
    }

    follows : ApiFollowedTopic[];
    user : User;

    get isMember () {
      return this.user && this.user.entitled;
    }

    init() {

        this.subscribe(this.userService.userChanged, user => {
            this.user = user;
            this.fetchFollowStatus();
        });

        this.size = 30;

        let observer = combineLatest(this.route.queryParamMap, this.route.paramMap);
        observer.subscribe(async ([query, params]) => {
            let slug = params.get('topic');
            let page = parseInt(query.get('page') || '1');
            let offset = (page - 1) * this.size;
            this.page = page;
            this.fetchTopic(slug);
            this.fetchTopicFeed(slug, offset);
            this.isUTMCampaign = !!query.get('utm_campaign');
        });
    }
}
